import { render, staticRenderFns } from "./TextEditUI.vue?vue&type=template&id=1efe03e9&scoped=true&"
import script from "./TextEditUI.vue?vue&type=script&lang=js&"
export * from "./TextEditUI.vue?vue&type=script&lang=js&"
import style0 from "./TextEditUI.vue?vue&type=style&index=0&id=1efe03e9&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efe03e9",
  null
  
)

export default component.exports